import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ContentsBase } from '@routes/tickets/ticket-edit/contents/contents-base';
import { finalize, takeWhile } from 'rxjs/operators';
import { TicketCreate } from '@shared/models/ticket-create';
import Utils from '@shared/utils/utils';
import { Sc4uInfo } from '@shared/models/sc4u-info';
import { Customer } from '@shared/models/customer';
import { Symptom } from '@shared/models/symptom';
import { Pricing } from '@shared/models/pricing';
import { Basic } from '@shared/models/basic';
import { Constants } from '@shared/constants/constants';
import { Company } from '@shared/enums/company';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent extends ContentsBase implements OnInit, OnDestroy, AfterViewInit {

  basic: Basic = {};
  customer: Customer = {};
  sc4uInfo: Sc4uInfo = {};
  symptoms: Symptom[] = [];
  pricing: Pricing = {};

  standard: number = null;
  lcd: number = null;
  standardTax: number = null;
  lcdTax: number = null;
  showPricing = false;

  ngOnInit(): void {
    // this.spinnerService.start('pricing');
    this.init('pricing');
    this.showPricing = this.company === Company.SeaIm;

    if (this.ticketService) {
      this.ticketService.data$
        .pipe(takeWhile(() => this.alive))
        .subscribe((ticket: TicketCreate) => {
          if (Utils.isEmpty(ticket)) {
            return;
          }

          ['basic', 'customer', 'sc4uInfo', 'symptoms', 'pricing'].forEach(x => {
            this[x] = ticket[x];
          });

          if (this.isDetail) {
            if (this.pricing) {
              if (this.pricing.amount === 0) {
                this.showPricing = false;
              }
            }
            return;
          }

          if (Utils.isEmpty(this.pricing)) {
            this.load();
          }
        });
    }
  }

  ngAfterViewInit(): void {
    // this.ticketService.scrollToBottom();
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  load() {
    if (!this.symptoms) {
      return;
    }

    const { serviceType } = this.basic;
    const { zipcode } = this.customer?.address;
    const { sc4uObjectId, dialogParts } = this.sc4uInfo;
    const symptoms = this.symptoms.map(m => {
      return m.code;
    });

    this.spinnerService.start();
    let getPrice = this.apiService.sc4u.getInHomeRepairPrice(sc4uObjectId, symptoms, zipcode, dialogParts);
    if (serviceType === Constants.serviceCode.PICKUP_SERVICE) {
      getPrice = this.apiService.sc4u.getCiPsRepairPrice(sc4uObjectId, serviceType, symptoms, zipcode, dialogParts);
    }

    getPrice
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {

        const { serviceType, price } = res;

        const isPS = serviceType === Constants.serviceCode.PICKUP_SERVICE;
        console.log('price =', price);
        console.log('isPS =', isPS);
        this.standard = isPS ? price.stdPrice?.gcicPrice || 0 : price.parts?.price * 1 + price.labor?.price * 1;
        this.standardTax = isPS ? price.stdPrice?.verTax || 0 : price.parts?.tax * 1 + price.labor?.tax * 1;
        this.lcd = isPS ? price.lcdPrice?.gcicPrice || 0 : 0;
        this.lcdTax = isPS ? price.lcdPrice?.verTax || 0 : 0;

        this.showPricing = (this.standard + this.standardTax + this.lcd + this.lcdTax) > 0;
        console.log('standard =', this.standard, ', standardTax =', this.standardTax, ', lcd =', this.lcd, ', lcdTax =', this.lcdTax);
        const pricing = {
          pricing: isPS ? {
            parts: {
              price: this.standard + this.lcd,
              tax: this.standardTax + this.lcdTax,
            },
          } : {
            parts: price.parts,
            labor: price.labor,
          },
          amount: this.standard + this.standardTax + this.lcd + this.lcdTax,
          status: false,
        };

        console.log('pricing after sum =', pricing);

        const data = {
          sc4uInfo: {
            ...this.sc4uInfo,
            pricing,
          },
          pricing: {
            ...pricing,
            serviceType: serviceType
          },
        };

        this.ticketService.patch(data, 'pricing');
      }, err => Utils.showError(err));
  }

}
